"use client";

import {
  DEFAULT_TOAST_PROPS
} from "./chunk-O7WEJWMN.mjs";
import {
  useToastTimer
} from "./chunk-LD2TY7UV.mjs";
import {
  observer
} from "./chunk-TTXFVJUR.mjs";
import {
  renderIcon
} from "./chunk-LYMIFGUZ.mjs";
import {
  EXIT_DURATION,
  byBreakpoints,
  toastAddonCss,
  toastBaseCss,
  toastMessageFontCss,
  toastMessageWrapperCss,
  toastPositionCss,
  toastSizeCss,
  toastStretchCss
} from "./chunk-JPXPBBHO.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-EX6ADWAR.mjs";

// src/Toast.tsx
import {
  mapResponsive,
  mapResponsiveElement,
  useBreakpointContext
} from "@teamsparta/stack-core";
import { Text } from "@teamsparta/stack-text";
import { primitiveColor } from "@teamsparta/stack-tokens";
import { Fragment } from "react";
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function Toast(props) {
  const {
    id,
    size = DEFAULT_TOAST_PROPS.size,
    type,
    message,
    position = DEFAULT_TOAST_PROPS.position,
    offset = DEFAULT_TOAST_PROPS.offset,
    duration = DEFAULT_TOAST_PROPS.duration,
    dismiss,
    immediateDismiss = DEFAULT_TOAST_PROPS.immediateDismiss,
    immediateEnter = DEFAULT_TOAST_PROPS.immediateEnter,
    stretch = DEFAULT_TOAST_PROPS.stretch,
    addon,
    onClickAddon
  } = props;
  const toastTimeHandler = useToastTimer({ toastId: id, duration });
  const breakpoints = useBreakpointContext("Toast");
  const sizes = mapResponsive(breakpoints, size, (breakpoint, size2) => ({
    breakpoint,
    size: size2
  }));
  const positions = mapResponsive(
    breakpoints,
    position,
    (breakpoint, position2) => ({
      breakpoint,
      position: position2
    })
  );
  const offsets = mapResponsive(breakpoints, offset, (breakpoint, offset2) => ({
    breakpoint,
    offset: offset2
  }));
  const stretchs = mapResponsive(
    breakpoints,
    stretch,
    (breakpoint, stretch2) => ({
      breakpoint,
      stretch: stretch2
    })
  );
  const addons = mapResponsiveElement(
    breakpoints,
    addon,
    (breakpoint, addon2) => ({
      breakpoint,
      node: addon2
    })
  );
  function handleClickAddon() {
    onClickAddon == null ? void 0 : onClickAddon();
    observer.dismiss(id);
    setTimeout(() => {
      observer.delete(id);
    }, EXIT_DURATION);
  }
  return /* @__PURE__ */ jsxs(
    "div",
    __spreadProps(__spreadValues({
      css: [
        toastBaseCss(type),
        type !== "custom" && toastSizeCss(sizes),
        type !== "custom" && toastStretchCss(stretchs),
        toastPositionCss({
          positions,
          offsets,
          dismiss,
          immediateDismiss,
          immediateEnter
        })
      ]
    }, toastTimeHandler), {
      children: [
        renderIcon({ type, sizes }),
        type !== "custom" && typeof message === "string" ? /* @__PURE__ */ jsx("div", { css: toastMessageWrapperCss(sizes), children: /* @__PURE__ */ jsx(
          Text,
          {
            as: "span",
            color: DEFAULT_TOAST_PROPS.messageColor,
            style: { width: "max-content" },
            css: toastMessageFontCss(sizes),
            children: message
          }
        ) }) : message,
        typeof addon === "string" ? /* @__PURE__ */ jsx(
          Text,
          {
            tabIndex: 0,
            role: "button",
            as: "span",
            font: "captionSb",
            color: primitiveColor.neutral[20],
            css: [toastAddonCss],
            onClick: handleClickAddon,
            children: addon
          }
        ) : /* @__PURE__ */ jsx(Fragment, { children: addon && /* @__PURE__ */ jsx("span", { css: [toastAddonCss], onClick: handleClickAddon, children: byBreakpoints(addons) }) })
      ]
    })
  );
}

export {
  Toast
};
